import { type FC, type PropsWithChildren } from 'react';

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="w-full h-full flex justify-center">
      <div className="w-[40rem] flex flex-col items-center">{children}</div>
    </div>
  );
};
